import { env } from 'config/env';
import { useEffect } from 'react';
import { FF, useSplitFlag } from 'modules/feature-flags';
import analytics from 'modules/analytics';
import { globalContext } from 'modules/analytics/constants';

export enum BackgroundTabActive {
  FAVICON = 'favicon',
  NOTIFICATION = 'notification',
  ALL = 'all_mitigations', // 'all' is not an allowed treatment name
  NONE = 'none',
}

const FAVICON_UPDATABLE = [BackgroundTabActive.FAVICON, BackgroundTabActive.ALL];
const NOTIFICATION_REQUESTABLE = [BackgroundTabActive.NOTIFICATION, BackgroundTabActive.ALL];

const requestNotificationPermission = () => {
  if (Notification.permission === 'granted') {
    // We already have the permission;
    analytics.addContext(
      globalContext.workspace.permissions('notification'),
      Notification.permission
    );
  } else if (Notification.permission !== 'denied') {
    Notification.requestPermission()
      .then((permission) => {
        if (permission === 'granted') {
          new Notification('Sirona - Successful Permission Request');
        }
      })
      .catch(() => {})
      .finally(() => {
        analytics.addContext(
          globalContext.workspace.permissions('notification'),
          Notification.permission
        );
      });
  } else {
    analytics.addContext(
      globalContext.workspace.permissions('notification'),
      Notification.permission
    );
  }
};

export const useKeepAliveTab = () => {
  const [tabStrat] = useSplitFlag<BackgroundTabActive>(FF.KEEP_BACKGROUND_TAB_ACTIVE);

  const faviconUpdatable = FAVICON_UPDATABLE.includes(tabStrat);
  const notificationRequestable = NOTIFICATION_REQUESTABLE.includes(tabStrat);

  useEffect(() => {
    const handler = () => {
      if (document.visibilityState === 'hidden' && faviconUpdatable) {
        const link = document.createElement('link');
        const oldLink = document.getElementById('dynamic-favicon');

        link.id = 'dynamic-favicon';
        link.rel = 'icon';
        link.href = `/env/${env.DEPLOY_ENV}/favicon.svg`;
        if (oldLink) {
          document.head.removeChild(oldLink);
        }
        document.head.appendChild(link);
      }
    };

    document.addEventListener('visibilitychange', handler);

    return () => {
      document.removeEventListener('visibilitychange', handler);
    };
  }, [faviconUpdatable]);

  useEffect(() => {
    if (notificationRequestable) {
      requestNotificationPermission();
    }
  }, [notificationRequestable]);
};
